<template>

<div class="text-center padding30">
    <p class="margint40 marginb50">您还没有发布过内容</p>
    <img src="//image1.51tiangou.com/tgou2/img2/blank/blankNew/blankBasketList.png" alt="" class="marginv50">

    <p class="text-center text-light fs-12" style="margin-top:100px;" v-if="role == 'my' && isHybrid">发布新鲜内容还能领优惠券哟~</p>
    <div class="btn btn-big red block radius margint20" @click="publicDiscover" v-if="role == 'my' && isHybrid">发布</div>
</div>

</template>

<script>
export default {
    props:{
        role:{
            type: String,
            default: null
        }
        , isHybrid: {
        	type: Boolean
            , default: false
        }
    },
    computed:{
    },
    ready:function(){

    },
    methods:{
	    publicDiscover(){
	    	this.$dispatch('publicDiscover');
        }
    }
}
</script>

<style lang="scss">

</style>